module.exports = __webpack_public_path__ + "h5/img/pacific-insurance-logo.91af580e.svg";